import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://www.stuck-komzet.de/wp-json/tri/v1',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const formPost = axios.create({
  baseURL: 'https://www.stuck-komzet.de/wp-json/tri/v1',
  withCredentials: false,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

export default {
  getCSV(rid, userid, accessToken) {
    return apiClient.get(
      '/survey/get_csv/' + rid + '/' + userid + '/' + accessToken
    )
  },
  getWord(rid, userid, accessToken) {
    return apiClient.get(
      '/survey/get_word/' + rid + '/' + userid + '/' + accessToken
    )
  },
  getResults(sid, username, password) {
    return apiClient.get(
      '/survey/get_results/' + sid + '/' + username + '/' + password
    )
  },
  getSurveys() {
    return apiClient.get(
      '/survey/get_surveys_by_email_install/' + localStorage.username + '/2'
    )
  },
  getMenu(sid, userid, token) {
    //console.log("get menu "+sid+" "+userid+" "+token);
    return apiClient.get(
      '/menus/itemsBox/box-' + sid + '/' + userid + '/' + token
    )
  },
  getToken(sid, username, password){
    return apiClient.get(
        '/survey/get_token/'+sid+'/'+username+'/'+password
    )
  },
  getMenuLogin(sid, username, password){
    console.log("get menu "+sid+" "+username+" "+password);
    return apiClient.get(
        '/menus/itemsBox/box-' + sid + '/' + username + '/' + password
    )
  },
  async updateMenu(
    menu_id,
    items,
    accessToken,
    user_id,
    survey_id,
    username,
    password
  ) {
    /*console.log("userid: "+user_id);
    console.log("token: "+accessToken);*/

    await this.activateGroups(0)
    let data = new FormData()
    data.append('accessToken', accessToken)
    data.append('items', JSON.stringify(items))
    data.append('menu_id', menu_id)
    data.append('user_id', user_id)
    data.append('survey_id', survey_id)
    data.append('username', username)
    data.append('password', password)
    let res = await formPost.post('/survey/update_menu', data)
    await this.activateGroups(1)
    return res
  },
  activateGroups(activate) {
    return apiClient.get('/survey/activate_groups/' + activate)
  },
  deleteMenuItem(menu_id, item_id, user_id, accessToken) {
    //console.log(user_id+" "+item_id+" "+menu_id+" "+accessToken)
    let res = apiClient.get(
      '/survey/delete_item/' +
        menu_id +
        '/' +
        item_id +
        '/' +
        user_id +
        '/' +
        accessToken
    )
    return res
  }
}
